import styled from 'styled-components'
import React, { useMemo, useCallback, } from 'react'
import { useNavigate, useLocation, } from 'react-router-dom'

import { AgentSummary, InfiniteScrollbar, } from '@components'

import { Agent, } from '@types'

interface Props {
  agents: Array<Agent>
  onAgentSelect: (agent: Agent) => () => void
  onEndReached: () => void
  className?: string
  selectedAgentId?: string
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(247, 250, 252, 0.96) 100%);

  .header {
    display: flex;
    align-items: center;
    min-height: 72px;
    padding: 0 18px;
    background: linear-gradient(135deg, rgb(48, 63, 159) 0%, rgb(67, 81, 249) 48%, rgb(99, 102, 241) 100%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);
    box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.08);

    h2 {
      font-size: 20px;
      font-weight: 800;
      letter-spacing: -0.02em;
      color: white;
      text-shadow: 0 1px 2px rgba(15, 23, 42, 0.18);
    }
  }

  .agent-summary-list {
    flex: 1;
    padding: 4px 0 10px;
    background:
      linear-gradient(180deg, rgba(255, 255, 255, 0.55) 0%, rgba(241, 245, 249, 0.72) 100%);

    .search-result-description-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 28px 14px 12px;
      padding: 18px 14px;
      border-radius: 14px;
      border: 1px solid rgba(148, 163, 184, 0.2);
      background-color: rgba(255, 255, 255, 0.9);
      color: rgb(71, 85, 105);
      text-align: center;

      p {
        line-height: 1.5;
      }

      button {
        min-width: 110px;
        height: 38px;
        margin-top: 14px;
        border: 0;
        border-radius: 10px;
        background: linear-gradient(135deg, rgb(67, 81, 249) 0%, rgb(79, 70, 229) 100%);
        color: white;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
`

function AgentList(props: Props) {
  const { agents, className, onAgentSelect, onEndReached, selectedAgentId, } = props

  const location = useLocation()
  const navigate = useNavigate()

  const agentSearchValue = useMemo(
    () => {
      const urlParams = new URLSearchParams(location.search)
      return urlParams.get('search-agent')
    },
    [ location, ]
  )

  const onResetSearchClick = () => {
    navigate('/')
  }

  return (
    <Container className={ className }>
      <div className='header'>
        <h2>
          평가사 목록
        </h2>
      </div>
      <InfiniteScrollbar
        onEndReached={ onEndReached }
        style={{ flex: 1, minHeight: 0, }}>
        <div className='agent-summary-list'>
          {
            agents.map((agent, index) => {
              return (
                <AgentSummary
                  onClick={ onAgentSelect(agent) }
                  key={ `agent-summary-${ index }` }
                  agent={ agent }
                  style={{
                    ... (index === agents.length - 1 ? {
                      marginBottom: 0,
                      borderBottomWidth: 0,
                    } : {}),
                  }}
                />
              )
            })
          }
          {
            agentSearchValue && (
              <div className='search-result-description-container'>
                <p><b>{ agentSearchValue }</b>으로 검색한 평가사 목록입니다.</p>
                <button onClick={ onResetSearchClick }>검색 초기화</button>
              </div>
            )
          }
        </div>
      </InfiniteScrollbar>
    </Container>
  )
}

export default styled(AgentList)``
